import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import { FormattedMessage, useIntl } from "react-intl";
const useServiceItem = () => {
  const icons = {
    CategoryOutlinedIcon,
    LocationCityOutlinedIcon,
  };

  const servicceItems = {
    id: "group-service-managment",
    title: (
      <FormattedMessage id="Services Managment">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    icon: icons.CategoryOutlinedIcon,
    type: "group",
    // url: "/service-persons",

    children: [
      {
        id: "service-persons",
        title: <FormattedMessage id="Users Services" />,
        type: "item",
        url: "/service-persons",
        icon: icons.CategoryOutlinedIcon,
        breadcrumbs: false,
      },
      {
        id: "user-services",
        title: <FormattedMessage id="Companies Services" />,
        type: "item",
        url: "/user-services",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },
      {
        id: "user-service-request",
        title: <FormattedMessage id="Users Services Requests" />,
        type: "item",
        url: "/user-service-request",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },
      {
        id: "company-service-request",
        title: <FormattedMessage id="Companies Services Requests" />,
        type: "item",
        url: "/company-service-request",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },
    ],
  };

  return servicceItems;
};

export default useServiceItem;
